import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const useSimilarGoods = (enabled: boolean) => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.similarGoods(goodsSno),
    queryFn: () => goodsService.getSimilarGoods(goodsSno),
    enabled,
  });
};
